// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewsletterSignup-module--wrapper--1JXb8","form":"NewsletterSignup-module--form--ltmjW","formWrapper":"NewsletterSignup-module--form-wrapper--3ABFf"};